import { render, staticRenderFns } from "./deviceRelation.vue?vue&type=template&id=23303dff&scoped=true"
import script from "./deviceRelation.vue?vue&type=script&lang=js"
export * from "./deviceRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23303dff",
  null
  
)

export default component.exports